export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('StatesUtils', (inicialStateKey = '') => ({
        stateKey: inicialStateKey,
        stateValue: '',
        changeStateKey(key, value = '') {
          this.stateKey = key;
          this.stateValue = value.toLowerCase().replace(/\s+/g, '-');
        },
        redirectToURL(baseURL) {
          let link = baseURL;
          if (this.stateKey) {
            if (baseURL[baseURL.length - 1] === '/') {
              link = baseURL + (this.stateValue ?? this.stateKey);
            } else link = baseURL + '?serviceState=' + this.stateKey;
          }
          window.location.href = link;
        },
      }));
    });
  },
};
